import buildRoute from '@/composables/build-route';

export default routeToCheck => {
	if (routeToCheck && routeToCheck.meta && routeToCheck.meta.accessWebRoute) {
		const route = buildRoute(
			routeToCheck.meta.accessWebRoute,
			routeToCheck.params
		);
		let url = `${window.location.protocol}//${window.location.hostname}`;
		let port = window.location.port;

		if (port) {
			url = `${url}:${port}`;
		}

		url = `${url}${route}`;

		window.location.assign(url);
	}
};
